import { Component, OnInit } from '@angular/core';
import { SettingsService } from 'src/app/services/settings.service';
import { TransactionService } from 'src/app/services/transaction.service';
import { ChartData } from 'src/app/shared/models/general/chart-data';
import { SearchRequest } from 'src/app/shared/models/general/search-request';
import { TransactionDataBundle } from 'src/app/shared/models/transactions/transaction-data-bundle';
import * as moment from 'moment';
import { ChartColors } from 'src/app/shared/models/general/chart-colors';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})

export class DashboardComponent implements OnInit {
  //General
  busy: boolean = false;
  welcomCardBusy: boolean = false;
  statCardsBusy: boolean = true;
  showError: boolean = false;
  errorMsg = "";
  currentYear = new Date().getFullYear().toString();

  //Weekly Stat cards
  statCardsSearchRequest: SearchRequest = new SearchRequest();
  statCardsTransactionDataBundle: TransactionDataBundle = new TransactionDataBundle();
  prevWeekStatCardsTransactionDataBundle: TransactionDataBundle = new TransactionDataBundle();
  statCardsFiaAvailable: number = 0;


  //Main yearly summary bar chart
  public chart1Type: string = 'bar';
  public chartDatasets: Array<ChartData> = [];
  public chartLabels: Array<any> = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul'];
  public chartColors: ChartColors[] = [];
  public chartOptions: any = {
    responsive: true,
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            callback: function (value: number) {
              return 'R' + value.toLocaleString();
            },
          },
        },
      ],
    },
    tooltips: {
      callbacks: {
        label: function (tooltipItem: any) {
          var data: number = tooltipItem.yLabel;
          return "R " + data.toLocaleString();
        }
      }
    }

  };
  yearlySummarySearchRequest: SearchRequest = new SearchRequest();
  yearlySummaryTransactionDataBundle: TransactionDataBundle[] = [];
  yearlySummaryBusy: boolean = false;

  constructor(public settingsService: SettingsService, public transactionsService: TransactionService) {

  }

  async ngOnInit() {
    this.busy = true;
    this.settingsService.ValidateGlobalVars().then(() => {
      this.GetTransactionDataForStatCards();
      this.GetTransactionDataForYearByMonth();
      this.busy = false;
    });
  }

  GetTransactionDataForStatCards() {
    this.statCardsBusy = true;
    this.errorMsg = "";
    this.showError = false;

    this.statCardsSearchRequest.id = this.settingsService.user.id;
    this.statCardsSearchRequest.entityType = this.settingsService.userEntity.id;
    this.statCardsSearchRequest.timePeriod = 2; //Week
    this.statCardsSearchRequest.fromDate = moment().startOf('month').format('YYYY-MM-DD');
    this.statCardsSearchRequest.toDate = moment().endOf('month').format('YYYY-MM-DD');

    this.transactionsService.GetTransactionDataBundleForEntity(this.statCardsSearchRequest).toPromise()
      .then(response => {
        this.statCardsTransactionDataBundle = response[0];
        this.statCardsFiaAvailable = this.statCardsTransactionDataBundle.fiaAvailable[0].fiaAvailable;

        this.statCardsSearchRequest.fromDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
        this.statCardsSearchRequest.toDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD'); 
        this.transactionsService.GetTransactionDataBundleForEntity(this.statCardsSearchRequest).toPromise()
          .then(response1 => {
            this.prevWeekStatCardsTransactionDataBundle = response1[0];
            this.statCardsBusy = false;
          },
            (error) => {
              this.showError = true;
              this.errorMsg = error.error.ErrorDetail;
              this.statCardsBusy = false;
            });
      },
        (error) => {
          this.showError = true;
          this.errorMsg = error.error.ErrorDetail;
          this.statCardsBusy = false;
        });
  }

  GetTransactionDataForYearByMonth() {
    this.yearlySummaryBusy = true;
    this.errorMsg = "";
    this.showError = false;

    this.yearlySummarySearchRequest.id = this.settingsService.user.id;
    this.yearlySummarySearchRequest.entityType = this.settingsService.userEntity.id;
    this.yearlySummarySearchRequest.timePeriod = 2; //month
    this.yearlySummarySearchRequest.fromDate = new Date(new Date().getFullYear(), 0, 1).toLocaleDateString();
    this.yearlySummarySearchRequest.toDate = new Date().toLocaleDateString();

    this.transactionsService.GetTransactionDataBundleForEntity(this.yearlySummarySearchRequest).toPromise()
      .then(response => {
        this.yearlySummaryTransactionDataBundle = response;
        this.SetupYearlySummaryGraph(this.yearlySummaryTransactionDataBundle).then(() => {
          this.yearlySummaryBusy = false;
        });
      },
        (error) => {
          this.showError = true;
          this.errorMsg = error.error.ErrorDetail;
          this.yearlySummaryBusy = false;
        });
  }

  SetupYearlySummaryGraph(data: TransactionDataBundle[]) {
    return new Promise(resolve => {
      this.chartLabels = [];
      this.chartDatasets = [];
      var chartdata: ChartData = new ChartData();
      var chartColor: ChartColors = new ChartColors();

      data.forEach(x => {
        this.chartLabels.push(moment(x.fromDate).format("MMMM"));
        chartdata.data.push(x.totalTradeProfit);

        chartColor.backgroundColor.push("rgba(0, 200, 81, 0.2)");
        chartColor.borderColor.push("rgba(0, 200, 81, 1)");
      });

      chartdata.label = "Total Monthly Profit";
      this.chartDatasets.push(chartdata);
      this.chartColors.push(chartColor);
      resolve(true);
    });

  }
}
